import { render, staticRenderFns } from "./ObservacoesGeraisCartao.vue?vue&type=template&id=d6972028"
import script from "./ObservacoesGeraisCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./ObservacoesGeraisCartao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports